import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {WholesaleConstants} from '../constants/wholesale.constants';
import { ProductionOfferResponse } from '../models/production-offer-response.model';
import { WholesaleResponse } from '../models/wholesale-response.model';

@Injectable()
export class BulkOrderService {
	private getWersVehicleLineUrl = sessionStorage.getItem('baseBulkOrderCreationUrl') + WholesaleConstants.getWersVehicleLineUrl;
	private specificationMappedUrl = sessionStorage.getItem('baseBulkOrderCreationUrl') + WholesaleConstants.getSpecificationByMarketUrl;
	private saveSaveDealerMixByMarketAndVehicleLineUrl = sessionStorage.getItem('baseBulkOrderCreationUrl') + WholesaleConstants.saveSaveDealerMixUrl;

	constructor(private httpClient: HttpClient) {
	}

	getVehicleLineBoc(isSeer: boolean) {
		const params = new HttpParams().set('specificationMarket', sessionStorage.getItem('loggedInUserMarketCode'))
			.set('isSeer', String(isSeer));
		return this.httpClient.get<any>(this.getWersVehicleLineUrl, {
			headers: new HttpHeaders({
				Authorization: 'Bearer ' + sessionStorage.getItem('authToken')
			}), params
		});
	}

	getSpecificationsAndMixMapped(marketKey: string, vehicleLineCode: number, wholesaleMonth: any, productionMonth: any, dealerId: any, dealerProductionOffers: ProductionOfferResponse[]) {
		const params = new HttpParams()
			.set('productionMonth', productionMonth)
			.set('wholesaleMonth', wholesaleMonth)
			.set('dealerId', dealerId);
		return this.httpClient.post<any>(this.specificationMappedUrl + marketKey + '/vehicleline/' + vehicleLineCode + '/specifications/wersspecificationsentitydealermix', dealerProductionOffers, {
			headers: new HttpHeaders({
				Authorization: 'Bearer ' + sessionStorage.getItem('authToken')
			}), params
		});
	}

	saveDealerMixByMarketAndVehicleLine(dealerGroupMixList: any) {
		return this.httpClient.post(
			this.saveSaveDealerMixByMarketAndVehicleLineUrl  + 'vehicleline/savedealermix',
			dealerGroupMixList, {
				responseType: 'text',
				headers: new HttpHeaders({
					Authorization: 'Bearer ' + sessionStorage.getItem('authToken')
				})
			});
	}
}
